import { render, staticRenderFns } from "./PlayerStarAbandoned.vue?vue&type=template&id=42352c94&scoped=true&"
import script from "./PlayerStarAbandoned.vue?vue&type=script&lang=js&"
export * from "./PlayerStarAbandoned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42352c94",
  null
  
)

export default component.exports